import { render, staticRenderFns } from "./renewalRecord.vue?vue&type=template&id=f8d9bdb4&scoped=true&"
import script from "./renewalRecord.vue?vue&type=script&lang=js&"
export * from "./renewalRecord.vue?vue&type=script&lang=js&"
import style0 from "./renewalRecord.vue?vue&type=style&index=0&id=f8d9bdb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d9bdb4",
  null
  
)

export default component.exports